// extracted by mini-css-extract-plugin
export default {"colorText":"oea-z","colorTextLabel":"pea-z","colorTextValue":"qea-z","swatches":"rea-z","collapseLink":"sea-z","isCollapsed":"tea-z","dropdown":"uea-z","disabled":"vea-z"};